import { Segmented } from "antd";
import { ComponentProps } from "react";

export enum TabType {
  账号管理,
  我的订单,
  微力记录,
}

export const tabOption: ComponentProps<typeof Segmented>['options'] = [
  { label: '账号管理', value: TabType.账号管理 },
  { label: '我的订单', value: TabType.我的订单 },
  { label: '微力记录', value: TabType.微力记录 },
]

export enum MemberType {
  免费版,
  WIME会员,
  WIME会员已过期,
}